import HeaderBar from '../components/HeaderBar';
import {connect} from 'react-redux';
import { withRouter } from 'react-router'
import { clearResponse } from '../actions/response';
import { getResponse, getResults } from '../reducer/response';
import {signOut} from '../actions/auth';
import { makeTitle } from '../reducer';
import { updateTrForResponse } from '../actions/translation';

//TODO: use one central section title translation
const sectionTitles = {
  monitoring: "Data Collection",
  assessment: "Assessment",
  controlRules: "Management Measures",
  enforcement: "Enforcement"
};
// TODO: MAke use of extracted LeftMenuButton component
let mapStateToProps = (state, ownProps) => {
  let readOnly = false;
  if (ownProps.params.id || (ownProps.params.idOrSection && ["monitoring", "assessment", "controlRules"].indexOf(ownProps.params.idOrSection) === -1)) {
    readOnly = true;
  }
  let responseID = readOnly ? ownProps.params.id || ownProps.params.idOrSection : "123";
  let response = getResponse(state);
  let results = getResults(state);
  let inResults = ownProps.inResults;
  let inAnswers = ownProps.inAnswers;
  let inOptions = ownProps.inOptions;
  let inHarvestStrategy = ownProps.inHarvestStrategy;
  let section = false;
  if (inResults) {
    section = ownProps.params.idOrSection;
    if (inResults && readOnly) {
      section = ownProps.params.section;
    }
  }

  let breadcrumbs = [];
  if (inResults) {
    breadcrumbs.push({
      "Results": `/questionnaire/results/${readOnly ? `${responseID}/` : "" }monitoring`
    });
    if (section) {
      breadcrumbs.push({
        [sectionTitles[section]]: `/questionnaire/results/${readOnly ? `${responseID}/` : "" }${section}`
      });
    }
    if(inHarvestStrategy){
      breadcrumbs.push({
        "Harvest Strategy": `/questionnaire/results/${readOnly ? `${responseID}/` : "" }harvestStrategy`
      })
    }

    if (inAnswers) {
      breadcrumbs.push({
        "Answers": `/questionnaire/results/${readOnly ? `${responseID}/` : "" }answers`
      });
    } else if (inOptions) {
      breadcrumbs.push({
        "Options": `/questionnaire/results/${readOnly ? `${responseID}/` : "" }${section}/options`
      });
    }
  }
  if (!inResults && response) {
    breadcrumbs.push({
      "My Fisheries": "/home"
    });
    breadcrumbs.push({
      [makeTitle(response)]: window.location
    });
  }

  var enfComplete = results["enforcement"].complete;

  return {
    saving: state.sync.isSyncing,
    syncError: state.sync.syncError,
    breadcrumbs,
    responseID: responseID,
    inResults,
    section,
    readOnly,
    email: state.auth.email,
    name: state.auth.name,
    isAdmin: state.auth.isAdmin,
    enfComplete: enfComplete,
    translationList: state.translationList.filter(tr => tr.published),
    trIDForResponse: response ? response.userEdits.trIDForResponse : -1,
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
    clearResponse: () => dispatch(clearResponse()),
    onSignOut: () => dispatch(signOut()),
    handleTrChangeForResponse: (trID, responseID) => dispatch(updateTrForResponse(trID, responseID))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HeaderBar));
